import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 380px;
  }
  .text-pairing-body {
    max-width: 544px;
    line-height: 32px;
  }
  ${themeMediaQuery('sm')} {
    .text-pairing-title {
      max-width: 544px;
    }
    .text-pairing-body {
      max-width: 430px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 544px;
    }
    .text-pairing-body {
      max-width: 544px;
    }
  }
`;

export const MainBackgroundImage = styled(Flex)<{
  backgroundImage: string;
}>`
  background-color: #ffffff;
  width: 100%;
  height: 1300px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  padding-top: 126px;
  background: url(${(props) => cloudAssetUrl(props.backgroundImage, { optimization: 'aggressive' })});
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;
  ${themeMediaQuery('below_sm')} {
    height: 700px;
    background-size: 150%;
    background-position: -30px bottom;
    /* z-index: -1; */
  }
  ${themeMediaQuery('sm')} {
    margin-top: -130px;
    height: 1000px;
  }
  ${themeMediaQuery('md')} {
    height: 1200px;
  }
  ${themeMediaQuery('lg')} {
    height: 1300px;
  }
  ${themeMediaQuery('xl')} {
    margin-top: -130px;
  }
  @media (min-width: 550px) and (max-width: 830px) {
    z-index: -1;
  }
`;

export const StyledMobileSection = styled(Box)`
  position: relative;
  width: 100vw;
`;

export const StyledBox = styled(Flex)`
  flex-direction: column;
  ${themeMediaQuery('below_sm')} {
    width: 90vw;
  }
  ${themeMediaQuery('sm')} {
    width: max-content;
  }
`;

export const NoFeeCashEverWrapper = styled(Flex)`
  opacity: 0.9;
  border-radius: 27px;
  width: 100%;
  position: relative;
  z-index: 1;
  ${themeMediaQuery('below_sm')} {
    width: 95%;
    justify-content: space-around;
    height: 100px;
  }
  ${themeMediaQuery('md')} {
    transform: scale(1);
  }
`;

export const StyledMobileImage = styled(CloudImage)`
  object-fit: contain;
  margin-top: ${themeSpace(8)};
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;
